import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateGenAnswer, updateOSContacts } from "../../redux/action/genericSurveyAction";
import store from "../../redux/store";
import { Card, Form } from "@deere/ux.uxframe-react";
import { Grid, Typography, TextField, FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox, Box, RadioGroup, FormHelperText, Radio, SelectField, Option } from "@deere/fuel-react";
import { findAnswerIndex, getTranslation, getLDTranslation, findSelectionIndex, getNewCheckValueAnswer, containsCheckBoxAnswer } from "../../utils/utils";
import { EMPTY_BODY, SECTION_TYPES, DEFAULT_GRID_COLLUMNS, OS_CONTACT_PARENT, OS_CONTACT_PARENT_ANS, OS_CONTACT_QUE_KEYS } from "../../utils/surveyLiterals";
import "../../assets/css/Sections.css";
import { getValidator } from "../../utils/validationRequiredFactory";
import { useOktaAuth } from "@okta/okta-react";
import { useTranslation } from "react-i18next";
import OSContactSection from "./OSContactSection";
import { useUserInfo } from "../../providers/userProvider";
import { showInputTextErorr } from "../../utils/validation";
import { getCountry } from "../../services/external.service";

const shouldRender = (question, answers, review, questions) => {
  let shouldRender = true;
  if (review && (!answers || answers.length === 0)) {
    // Case where user has not started working on survey yet - show all
    return shouldRender;
  }
  let queToCheck = question;
  while (queToCheck.idQuestionDepends !== null && queToCheck.idSelectionDependson !== null && shouldRender) {
    shouldRender = false;
    let parentQuestion = questions.find((ques) => parseInt(ques.id) === parseInt(queToCheck.idQuestionDepends));
    if (answers && answers.length > 0) {
      let parentAnswer = answers.find((ans) => parseInt(ans.questionId) === parseInt(queToCheck.idQuestionDepends));
      if (queToCheck.regexp === "notdepends") {
        if (parentAnswer && parentAnswer.answer && !parentAnswer.answer.toString().includes(queToCheck.idSelectionDependson.toString())) {
          shouldRender = true;
        }
      } else {
        if (parentQuestion.type === "CHECK" && parentAnswer && parentAnswer.answer.split(",").includes(queToCheck.idSelectionDependson.toString())) {
          shouldRender = true;
        } else if (parentAnswer && parentAnswer.answer.toString() === queToCheck.idSelectionDependson.toString()) {
          shouldRender = true;
        }
      }
      queToCheck = parentQuestion;
    }
    queToCheck = parentQuestion;
  }
  return shouldRender;
};

const shouldOSRender = (data, contact, questions) => {
  let shouldRender = true;
  if (data && data.idQuestionDepends !== null && data.idSelectionDependson !== null) {
    shouldRender = false;
    let parent = questions.find((q) => q.id === data.idQuestionDepends);
    if (contact[OS_CONTACT_QUE_KEYS[parent.code]] == data.idSelectionDependson) {
      shouldRender = true;
    }
  }
  return shouldRender;
};

export default function OSSectionPage({ survey, section, review, questionsToValidate, setAnswers, answers, isSubmit, setIsSubmitted, ownershipContact }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const surveyResponse = useSelector((state) => state.genericSurvey.surveyResponses[survey.code]);
  const surveyForm = useSelector((state) => state.genericSurvey.surveyAnswersForm[survey.code]);
  const osContactForm = useSelector((state) => state.genericSurvey.osContactForm);
  const campaignAssigned = useSelector((state) => state.campaign.campaignAssigned);
  const questions = section.questions.filter((qu) => qu.active).sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1));
  const requiredValidator = getValidator(survey.code);
  const { authState } = useOktaAuth();
  const userInfo = useUserInfo();
  const [osContacts, setOSContacts] = useState([]);
  const [countryList, setCountryList] = useState([]);

  useEffect(() => {
    if (surveyResponse && surveyResponse.surveyAnswers) {
      if (!review) {
        if (surveyForm.length > 0) setAnswers([...surveyForm]);
        else setAnswers([...surveyResponse.surveyAnswers]);
      }
    }
    if (!review && surveyResponse && surveyResponse.ownershipContact) {
      if (osContactForm.length > 0) setOSContacts([...osContactForm]);
      else setOSContacts([...surveyResponse.ownershipContact]);
    } else if (review && ownershipContact) setOSContacts([...ownershipContact]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [surveyResponse, campaignAssigned, ownershipContact]);

  useEffect(() => {
    if (!review && section && answers.length > 0 && osContacts.length === 0) {
      let queContactParent = section.questions.find((que) => que.code === OS_CONTACT_PARENT);
      if (queContactParent) {
        let queContactParentAns = answers.find((ans) => ans.questionId === queContactParent.id);
        if (queContactParentAns && queContactParentAns.answer === OS_CONTACT_PARENT_ANS) {
          handleAddAnother();
        }
      }
    }
  }, [section, answers, review]);

  useEffect(() => {
    getCountry(authState.accessToken.accessToken)
      .then((res) => {
        if (res.length > 0) {
          res.sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0));
          setCountryList(res);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  if (!section) return EMPTY_BODY;

  const updateAnswer = (e, questionId, data, contact) => {
    setIsSubmitted(false);
    if (data.code.includes("MULTI")) {
      updateOSContactAns(e, data, contact);
    } else {
      if (data.code && OS_CONTACT_PARENT === data.code && e.target && e.target.value === OS_CONTACT_PARENT_ANS && osContacts.length === 0) {
        handleAddAnother();
      }
      dispatch(updateGenAnswer({ questionId: questionId, answer: e.target ? e.target.value : e, surveyCode: survey.code }));
      setAnswers([...store.getState().genericSurvey.surveyAnswersForm[survey.code]]);
    }
  };

  const updateCheckAnswer = (e, question, exclusive) => {
    setIsSubmitted(false);
    const tmpValue = exclusive && e.target.checked ? e.target.value + "," : null;
    const exclusiveSelection = question.selections.find((s) => s.exclusive);
    let newCheckValue = exclusive ? tmpValue : getNewCheckValueAnswer(question.id, answers, e);

    if (newCheckValue === null || newCheckValue === "" || newCheckValue === ",") {
      //Remove Question
      dispatch(updateGenAnswer({ questionId: question.id, answer: "", surveyCode: survey.code }));
    } else {
      //Update Question
      if (newCheckValue.includes(exclusiveSelection.value)) {
        newCheckValue = e.target.value + ",";
      }
      dispatch(updateGenAnswer({ questionId: question.id, answer: newCheckValue, surveyCode: survey.code }));
    }
    setAnswers([...store.getState().genericSurvey.surveyAnswersForm[survey.code]]);
  };

  const updateOSContactAns = (e, data, contact) => {
    setIsSubmitted(false);
    let value = data.type === "RADIO" ? e.target.value == 1 : e.target.value;
    dispatch(updateOSContacts({ value: value, field: OS_CONTACT_QUE_KEYS[data.code], id: contact.id, contact: contact }));
    setOSContacts([...store.getState().genericSurvey.osContactForm]);
    if (data.children && data.children.length > 0) {
      clearChildrenResponses(e.target.value, data, contact);
    }
  };

  const clearChildrenResponses = (userResponse, data, contact) => {
    let osQueToClear = [];
    let fieldNamesToClear = [];
    data.children.forEach((item) => {
      if (userResponse != item.selectionDependson) {
        osQueToClear = osQueToClear.concat(item.children);
      }
    });
    osQueToClear.forEach((item) => {
      let fieldName;
      let queCode = section.questions.find((que) => {
        return que.id === item;
      });
      if (queCode) fieldName = OS_CONTACT_QUE_KEYS[queCode.code];
      if (fieldName) fieldNamesToClear.push(fieldName);
    });
    if (fieldNamesToClear.length > 0) {
      dispatch(updateOSContacts({ id: contact.id, fieldNamesToClear: fieldNamesToClear }));
    }
  };

  const deleteOSContact = (id) => {
    dispatch(updateOSContacts({ value: true, field: "deleted", id: id }));
    setOSContacts([...store.getState().genericSurvey.osContactForm]);
    let validContacts = store.getState().genericSurvey.osContactForm.filter((osc) => osc.deleted !== true);
    if (validContacts.length === 0) handleAddAnother();
  };

  function createRadioSection(data, contact) {
    let contactValue = contact ? contact[OS_CONTACT_QUE_KEYS[data.code]] : "";
    let indx = findAnswerIndex(data.id, answers);
    let answer = indx >= 0 ? answers[indx].answer : "";
    let selectionIdx = answer !== "" && answer ? findSelectionIndex(answer, data.selections) : -1;
    let selection = selectionIdx >= 0 ? data.selections[selectionIdx] : null;
    let required = review ? false : requiredValidator(data, section, answers, questionsToValidate);
    let render = contact ? shouldOSRender(data, contact, questions) : shouldRender(data, answers, review, questions);
    let isError = typeof isSubmit === "boolean" && isSubmit ? showInputTextErorr(answers, data.id) : false;
    if (contact && typeof isSubmit === "boolean" && isSubmit) {
      isError = contactValue === "" || contactValue === null ? true : false;
    }

    return (
      render && (
        <FormControl fullWidth>
          {review ? (
            <Box key={`b-${data.id}`}>
              <Typography size="sm" component="p" gutterBottom key={`q${data.questionId}`} paddingLeft={data.idQuestionDepends ? "1.5rem" : ""} fontWeight="semibold">
                {getTranslation(data, "text")}
              </Typography>
              <Typography size="sm" component="p" gutterBottom key={`a${data.questionId}`} paddingLeft={data.idQuestionDepends ? "1.5rem" : ""}>
                {selection !== null ? getTranslation(selection, "text") : ""}
              </Typography>
            </Box>
          ) : (
            <FormControl sx={{ m: 3 }} variant="standard" error={isError}>
              <FormLabel>
                <Typography size="sm" component="p" gutterBottom key={`${data.questionId}`} fontWeight="semibold">
                  {getTranslation(data, "text")}
                </Typography>
              </FormLabel>
              <RadioGroup name={`radioGroup-${data.id}`} id={`radioGroup-${data.id}`} row required>
                {data.selections
                  .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
                  .map((i) =>
                    i.active ? (
                      <FormControlLabel
                        sx={{
                          paddingLeft: data.idQuestionDepends ? 4 : 0,
                          alignItems: "start",
                          "& .MuiFormControlLabel-asterisk": { display: "none" },
                        }}
                        control={<Radio required={required !== undefined && required !== null ? required : data.required} />}
                        value={i.value}
                        id={i.id}
                        key={i.id}
                        label={
                          <Typography paragraph sx={{ textAlign: "justify", whiteSpace: "pre-wrap", marginTop: "3px" }}>
                            {getTranslation(i, "text")}
                          </Typography>
                        }
                        name={`${getTranslation(section, "description")}-${data.id}`}
                        onChange={(e) => updateAnswer(e, data.id, data, contact)}
                        data-testid={i.id}
                        checked={contact ? contactValue == i.value : indx >= 0 && answer && answer === i.value}
                      />
                    ) : (
                      ""
                    )
                  )}
              </RadioGroup>
              {isError ? <FormHelperText sx={{ color: "#c21020" }}>{t("bs_required")} </FormHelperText> : null}
            </FormControl>
          )}
        </FormControl>
      )
    );
  }

  function createCheckSection(data) {
    let indx = findAnswerIndex(data.id, answers);
    let answer = indx >= 0 ? answers[indx].answer : "";
    let required = review ? false : requiredValidator(data, section, answers, questionsToValidate);
    let isError = typeof isSubmit === "boolean" && isSubmit ? showInputTextErorr(answers, data.id) : false;
    return (
      shouldRender(data, answers, review, questions) && (
        <>
          <Typography size="sm" component="p" gutterBottom fontWeight="semibold" key={`q${data.questionId}`}>
            {getTranslation(data, "text")}
          </Typography>
          {
            <div id={data.questionId}>
              <>
                {review
                  ? data.selections
                      .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
                      .map((i) =>
                        i.active && answer === i.value.toString() ? (
                          <div key={i.id}>
                            <Typography size="sm" component="p" gutterBottom key={i.id}>
                              {" "}
                              {i !== null ? getTranslation(i, "text") : ""}
                            </Typography>
                            <br />
                          </div>
                        ) : (
                          ""
                        )
                      )
                  : data.selections
                      .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
                      .map((i) =>
                        i.active ? (
                          <FormControl error={isError} key={i.id}>
                            <FormGroup required={required !== undefined && required !== null ? required : data.required}>
                              <FormControlLabel
                                control={<Checkbox name={`${getTranslation(section, "description")}-${data.id}`} />}
                                sx={{
                                  alignItems: "start",
                                }}
                                value={i.value}
                                id={i.id}
                                key={i.id}
                                label={getTranslation(i, "text")}
                                name={`${getTranslation(section, "description")}-${data.id}`}
                                onChange={(e) => updateCheckAnswer(e, data, i.exclusive)}
                                data-testid={i.id}
                                checked={containsCheckBoxAnswer(i.value, answer)}
                              />
                            </FormGroup>
                            {isError ? <FormHelperText> {t("bs_required")}</FormHelperText> : null}
                          </FormControl>
                        ) : (
                          ""
                        )
                      )}
              </>
            </div>
          }
        </>
      )
    );
  }

  function createInput(data, contact) {
    let contactValue = contact ? contact[OS_CONTACT_QUE_KEYS[data.code]] : "";
    let required = review ? false : requiredValidator(data, section, answers, questionsToValidate);
    let indx = findAnswerIndex(data.id, answers);
    let isError = typeof isSubmit === "boolean" && isSubmit ? showInputTextErorr(answers, data.id) : false;
    let render = contact ? shouldOSRender(data, contact, questions) : shouldRender(data, answers, review, questions);
    if (contact && typeof isSubmit === "boolean" && isSubmit) {
      isError = contactValue === "" || contactValue === null ? true : false;
    }
    return (
      render &&
      (review ? (
        <>
          <Typography size="sm" component="p" gutterBottom key={`q${data.questionId}`} fontWeight="semibold">
            {getTranslation(data, "text")}
          </Typography>
          <Typography size="sm" component="p" gutterBottom key={`a${data.questionId}`}>
            {indx >= 0 ? answers[indx].answer : ""}
          </Typography>
        </>
      ) : (
        <>
          <TextField
            required={required !== undefined && required !== null ? required : data.required}
            onChange={(e) => updateAnswer(e, data.id, data, contact)}
            value={contact ? contactValue : indx >= 0 ? answers[indx].answer : ""}
            name={`${getTranslation(section, "description")}-${data.id}`}
            error={isError}
            variant="outlined"
            helperText={isError ? t("bs_required") : ""}
            label={getTranslation(data, "text")}
          />
        </>
      ))
    );
  }

  function createCountrySection(data, contact) {
    let contactValue = contact ? contact[OS_CONTACT_QUE_KEYS[data.code]] : "";
    const indx = findAnswerIndex(data.id, answers);
    const answer = indx >= 0 ? answers[indx].answer : -1;
    const country = answer ? countryList.find((c) => c.iso2CountryCode === answer.toString()) : null;
    let render = contact ? shouldOSRender(data, contact, questions) : shouldRender(data, answers, review, questions);
    let isError = typeof isSubmit === "boolean" && isSubmit ? showInputTextErorr(answers, data.id) : false;
    if (contact && typeof isSubmit === "boolean" && isSubmit) {
      isError = contactValue === "" ? true : false;
    }
    return (
      render &&
      (review ? (
        <>
          <Typography size="md" component="p" gutterBottom key={`a${data.questionId}`} fontWeight="semibold">
            {getTranslation(data, "text")}
          </Typography>
          <Typography size="md" component="p" gutterBottom key={`l${data.questionId}`}>
            {country ? country.name : ""}
          </Typography>
        </>
      ) : (
        <FormControl error={isError} variant="standard" sx={{ width: "100%" }}>
          <SelectField
            error={isError}
            id={`${getTranslation(section, "description")}-${data.id}`}
            label={getTranslation(data, "text")}
            key="originCountry"
            required
            size="medium"
            value={contactValue ? contactValue : ""}
            onChange={(e) => {
              updateAnswer(e, data.id, data, contact);
            }}
          >
            <Option disabled hidden value="">
              {t("lbl_dropdown_select")}
            </Option>
            {countryList && countryList.length > 0 ? (
              countryList.map((opt) => (
                <Option key={opt.iso2CountryCode} value={opt.name}>
                  {opt.name}
                </Option>
              ))
            ) : (
              <Option disabled selected value="">
                {t("tps_country_not_found")}
              </Option>
            )}
          </SelectField>
          {isError ? <FormHelperText> {t("bs_required")}</FormHelperText> : null}
        </FormControl>
      ))
    );
  }

  const renderSections = (section) => {
    if (section.type && SECTION_TYPES.includes(section.type.trim().toUpperCase())) {
      return (
        <OSContactSection
          questions={questions}
          getCollumnsByQuestion={getCollumnsByQuestion}
          createInput={createInput}
          createRadioSection={createRadioSection}
          createCountrySection={createCountrySection}
          answers={answers}
          osContacts={osContacts}
          handleAddAnother={handleAddAnother}
          review={review}
          deleteOSContact={deleteOSContact}
        />
      );
    }
    return questions
      .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
      .map((q) => {
        const collumnsByQuestion = q.questionsGroup ? getCollumnsByQuestion(questions, q.questionsGroup) : DEFAULT_GRID_COLLUMNS;
        return (
          <Grid key={`gq-${q.id}`} item md={collumnsByQuestion}>
            <div style={{ paddingLeft: 10, paddingRight: 10 }}>
              <Form.Row className="d-block mb-4">
                {q.type === "RADIO" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createRadioSection(q) : <></>}
                {q.type === "CHECK" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createCheckSection(q) : <></>}
                {q.type === "OPEN_SMALL" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createInput(q) : <></>}
              </Form.Row>
            </div>
          </Grid>
        );
      });
  };

  function getCollumnsByQuestion(questions, questionsGroup) {
    const questionsInGroup = questions.filter((q) => q.questionsGroup === questionsGroup);
    return questionsInGroup ? DEFAULT_GRID_COLLUMNS / questionsInGroup.length : DEFAULT_GRID_COLLUMNS;
  }

  const handleAddAnother = () => {
    let newContact = {
      id: assignIfUniqueID(),
      lastName: "",
      firstName: "",
      ownershipPercentage: "",
      isGovtAffiliated: null,
      countryOfCitizenship: "",
      jobTitle: "",
      positionWithGovtAgency: "",
      nameOfGovtAgency: "",
      createdBy: userInfo.userID,
    };
    dispatch(updateOSContacts({ contact: newContact }));
    setOSContacts([...store.getState().genericSurvey.osContactForm]);
  };

  const assignIfUniqueID = () => {
    let isUnique = true;
    let random = Math.floor(Math.random() * 10000) + 1;
    let randomID = "NewAdded_" + random;
    for (let i = 0; i < osContacts.length; i++) {
      if (isNaN(osContacts[i].id) && osContacts[i].id.split("_")[1] === random) {
        isUnique = false;
        break;
      }
    }
    if (isUnique) return randomID;
    else assignIfUniqueID();
  };

  return (
    <>
      <Card>
        <Card.Body id={section ? section.description : ""}>
          <Card.Title className="pb-3 font-weight-bold">{getTranslation(section, "description")}</Card.Title>
          <Card.Subtitle className="mb-4">{getLDTranslation(section, "longDescription")}</Card.Subtitle>
          <Grid container>{renderSections(section)}</Grid>
        </Card.Body>
      </Card>
    </>
  );
}
